module.exports = __webpack_public_path__ + "static/media/fcfm.29482caa.png";